import cookie from 'react-cookies'
import {
	FETCH_USER,
	FAIL_FETCH_USER,
	LOGIN,
	CLICK_LOGOUT,
	LOGOUT,
	CLICK_AGREE_TERMS,
	AGREE_TERMS,
	SEND_RESET_PASSWORD,
	FAIL_SEND_RESET_PASSWORD,
	SUCCESS_SEND_RESET_PASSWORD,
	COMPLETE_RESET_PASSWORD
} from '../actions';

const initialState = {
	isPrepared: false,
	isLoggedIn: false,
	user: {
		UserSeqNO: undefined,
		JigyoushaCD: undefined,
		JigyoushaName: undefined,
		KeiyakuKigyouCD: undefined,
		KeiyakuKigyouName: undefined,
		UserID: undefined,
		UserPassword: undefined,
		UserName: undefined,
		Furigana: undefined,
		Kengen: undefined,
		KengenName: undefined,
		IsSystemAdmin: false,
		IsJigyoushaAdmin: false,
		IsKeiyakuKigyouAdmin: false,
		IsNiukeshoOptionAvailable: false,
		IsNiukeshoPdfOptionAvailable: false,
		IsStatisticsOptionAvailable: false,
		IsMainOptionAvailable: false,
		IsArrivalOptionAvailable: false,
		IsIfmtOptionAvailable: false,
		IsEntryOptionAvailable: false,
		IsMappingOptionAvailable: false,
		IsDeliveryStatusOptionAvailable: false,
		IsDeliveryMobileReceiptOptionAvailable: false,
		IsReceiptArrivalPdfOptionAvailable: false,
		JigyoushaShubetsu: null,
		JigyoushaIsReceipt: false,
		JigyoushaIsMaker: false,
		JigyoushaIs3PL: false,
		JigyoushaIsChoai: false,
		JigyoushaIsNohinJigyousha: false,
		isKeiyakuKigyouMasterEditable: false,
		isJigyoushaMasterEditable: false,
		isAsnCorporateMasterEditable: false,
		isAsnHenkanMasterEditable: false,
		isHasonhoukokuKbnEditable: false,

	},
	todoAgree: false,
	termsFilePath: null,
	termsVersion: null,
	manualFilePath: null,
	policyFilePath: null,
	isFetching: false,
	error: undefined,
	jwt: '',
	SessionID: '8MaNCPpkgAwhium0NULW',
	sendpasswordError: null,
	isCompleteResetSend: false,
	mailAddress: '',
	limitMinutes: '30分'

};

export default function wtDetailSettings(state = initialState, action) {
	let ret = Object.assign({}, state, {});

	switch (action.type) {
		case FETCH_USER:
			ret.isFetching = true;
			ret.error = undefined;
			return ret;
		case FAIL_FETCH_USER:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.SessionID = undefined;
			cookie.remove('jigyousha_cd', {path: '/'});
			cookie.remove('password', {path: '/'});
			cookie.remove('user_id', {path: '/'});
			cookie.remove('SessionID', {path: '/'});
			return ret;
		case LOGIN:
			if (action.payload.auto_login) {
				const maxAge = 60 * 60 * 24 * 7 * 1; //seconds * minutes * hours * days * weeks
				cookie.save('jigyousha_cd', action.payload.JigyoushaCD, {path: '/', maxAge: maxAge});
				cookie.save('user_id', action.payload.UserID, {path: '/', maxAge: maxAge});
				cookie.save('password', action.payload.UserPassword, {path: '/', maxAge: maxAge});
				cookie.save('SessionID', action.payload.SessionID, {path: '/', maxAge: maxAge});
			}
			ret.isPrepared = true;
			ret.isLoggedIn = true;
			ret.user = {
				UserSeqNO: action.payload.UserSeqNO,
				JigyoushaCD: action.payload.JigyoushaCD,
				JigyoushaName: action.payload.JigyoushaName,
				KeiyakuKigyouCD: action.payload.KeiyakuKigyouCD,
				KeiyakuKigyouName: action.payload.KeiyakuKigyouName,
				UserID: action.payload.UserID,
				UserPassword: action.payload.UserPassword,
				UserName: action.payload.UserName,
				Furigana: action.payload.Furigana,
				Kengen: action.payload.Kengen,
				KengenName: action.payload.KengenName,
				IsSystemAdmin: (action.payload.IsSystemAdmin === "1"),
				IsJigyoushaAdmin: (action.payload.IsJigyoushaAdmin === "1"),
				IsKeiyakuKigyouAdmin: (action.payload.IsKeiyakuKigyouAdmin === "1"),
				IsNiukeshoOptionAvailable: (action.payload.IsNiukeshoOptionAvailable === "1"),
				IsNiukeshoPdfOptionAvailable: (action.payload.IsNiukeshoPdfOptionAvailable === "1"),
				IsStatisticsOptionAvailable: (action.payload.IsStatisticsOptionAvailable === "1"),
				IsMainOptionAvailable: (action.payload.IsMainOptionAvailable === "1"),
				IsArrivalOptionAvailable: (action.payload.IsArrivalOptionAvailable === "1"),
				IsIfmtOptionAvailable: (action.payload.IsIfmtOptionAvailable === "1"),
				IsEntryOptionAvailable: (action.payload.IsEntryOptionAvailable === "1"),
				IsMappingOptionAvailable: (action.payload.IsMappingOptionAvailable === "1"),
				IsDeliveryStatusOptionAvailable: (action.payload.IsDeliveryStatusOptionAvailable === "1"),
				IsDeliveryMobileReceiptOptionAvailable: (action.payload.IsDeliveryMobileReceiptOptionAvailable === "1"),
				IsReceiptArrivalPdfOptionAvailable: (action.payload.IsReceiptArrivalPdfOptionAvailable === "1"),
				JigyoushaShubetsu: action.payload.JigyoushaShubetsu,
				JigyoushaIsReceipt: (action.payload.JigyoushaIsReceipt === "1"),
				JigyoushaIsMaker: (action.payload.JigyoushaIsMaker === "1"),
				JigyoushaIs3PL: (action.payload.JigyoushaIs3PL === "1"),
				JigyoushaIsNohinJigyousha: (action.payload.JigyoushaIsNohinJigyousha === "1"),
				JigyoushaIsChoai: (action.payload.JigyoushaIsChoai === "1"),
				isKeiyakuKigyouMasterEditable: (action.payload.isKeiyakuKigyouMasterEditable === "1"),
				isJigyoushaMasterEditable: (action.payload.isJigyoushaMasterEditable === "1"),
				isReceiptsReferencesMasterEditable: (action.payload.isReceiptsReferencesMasterEditable === "1"),
				isAsnCorporateMasterEditable: (action.payload.isAsnCorporateMasterEditable === "1"),
				isAsnHenkanMasterEditable: (action.payload.isAsnHenkanMasterEditable === "1"),
				isHasonhoukokuKbnEditable: (action.payload.isHasonhoukokuKbnEditable === "1")
			};
			ret.SessionID = action.payload.SessionID;
			ret.isFetching = false;
			ret.todoAgree = action.payload.todoAgree;
			ret.termsFilePath = action.payload.termsFilePath;
			ret.termsVersion = action.payload.termsVersion;
			ret.manualFilePath = action.payload.manualFilePath;
			ret.policyFilePath = action.payload.policyFilePath;
			ret.error = undefined;
			ret.jwt = action.payload.jwt;
			return ret;
		case CLICK_LOGOUT:
			return Object.assign({}, state, action.payload);
		case LOGOUT:
			Object.keys(initialState).forEach((keys) => {
				ret[keys] = initialState[keys];
			});
			cookie.remove('jigyousha_cd', {path: '/'});
			cookie.remove('password', {path: '/'});
			cookie.remove('user_id', {path: '/'});
			cookie.remove('SessionID', {path: '/'});
			ret.isPrepared = true;
			ret.error = 'ログアウトされました';

			return ret;
		case CLICK_AGREE_TERMS:
			return Object.assign({}, state, action.payload);
		case AGREE_TERMS:
			ret.todoAgree = false;
			return ret;
		case SEND_RESET_PASSWORD:
			ret.mailAddress = action.payload.mail_address;
			ret.isFetching = true;
			ret.sendpasswordError = null
			return ret;
		case FAIL_SEND_RESET_PASSWORD:
			ret.isFetching = false;
			ret.sendpasswordError = action.payload.err;
			return ret;
		case SUCCESS_SEND_RESET_PASSWORD:
			ret.isFetching = false;
			ret.isCompleteResetSend = true;
			ret.limitMinutes = action.payload.data.limitMinutes
			return ret;
		case COMPLETE_RESET_PASSWORD:
			return Object.assign({}, state, action.payload);
		default:
			return state;
	}
}




// WEBPACK FOOTER //
// ./src/reducers/auth.js